import React from 'react';

import OrderForm from '@/components/blocks/forms/order-form';
import { CreateGuard } from '@/components/guards/permission-guards';
import { useGlobalState } from '@/contexts/GlobalStateContext';
import type { OrderCreateSheetProps } from '@/types/module';
import { RESOURCES } from '@/utils/permissions';

const OrderCreateSheet: React.FC<OrderCreateSheetProps> = ({
  onOrderCreated,
}) => {
  const { hideSheet } = useGlobalState();

  const handleSuccess = async () => {
    hideSheet('create-order');
    await onOrderCreated?.();
  };

  const handleCancel = () => {
    hideSheet('create-order');
  };

  return (
    <CreateGuard resource={RESOURCES.SALES_ORDERS}>
      <OrderForm
        mode='create'
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </CreateGuard>
  );
};

export default OrderCreateSheet;
